import about from '../images/about.png'
import code from '../images/code.png'
const aboutdata =[

{
    title:"Hi! I am Tahsin Sumiya",
    desc :"Ï am a frontend developer.i am very fond of designing and loves to design. i have a great passion in sketching So from starting of my university life i started taking interest in design and that lead me to frontend development"
    ,
    image:about,
    image2:code,
    link1:'https//:tahsinsumiya.19300137rpsu.edu.bd',
    link2:'https://github.com/TahsinSumiya',
    link3:'https://www.linkedin.com/in/tahsin-sumiya-1273a4257',
   
}


];
export default aboutdata